// Someone signed out on /connect is on their way to installing, and the site's install pages do that
// without an account (signing in happens inside the install). ?tool= picks that tool's page; every
// other query parameter (src, utm_*) goes along so the site credits the visit to the right channel.
//
// The exception is a visitor who came for their key: /plugin (the agent's "paste a key" fallback and
// the site's "Use a key instead") arrives as /connect?signin and keeps the sign-in.
export const SITE_INSTALL = "https://www.assertion-ai.com/install";

const TOOL_PAGES = { claude: "claude-code", "claude-code": "claude-code", cursor: "cursor", codex: "codex" };

export function siteInstallUrl(search = "") {
  const q = new URLSearchParams(search);
  const page = TOOL_PAGES[(q.get("tool") || "").toLowerCase()];
  q.delete("tool");
  q.delete("signin");
  const rest = q.toString();
  return `${SITE_INSTALL}${page ? `/${page}` : ""}${rest ? `?${rest}` : ""}`;
}

export function wantsSignIn(search = "") {
  return new URLSearchParams(search).has("signin");
}
